import { render, staticRenderFns } from "./JSelectPosition.vue?vue&type=template&id=71965468&scoped=true&"
import script from "./JSelectPosition.vue?vue&type=script&lang=js&"
export * from "./JSelectPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71965468",
  null
  
)

export default component.exports